import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative mb-x6" }
const _hoisted_2 = { class: "absolute mt-5 text-12" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "text-dusty-grey"
}
const _hoisted_5 = { class: "relative mb-x6" }
const _hoisted_6 = { class: "absolute mt-5 text-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick"]

import { computed, ref, watch } from 'vue';
import { CustomerType } from '@/b2c/shared/address/ui/base-address-form.types';
import InputText from '@/shared/form/InputText.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import { useField } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInfoForm',
  emits: ['input'],
  setup(__props, { emit }) {

const labels = useBlockLabels();


const { value: companyName, setValue: setCompanyName } = useField<string>('companyName');
const { value: vatNumber, setValue: setVatNumber } = useField<string>('vatNumber');
const customerTypeByFormData = computed<CustomerType>(() => companyName.value || vatNumber.value ? CustomerType.B2B : CustomerType.B2C);
const selectedCustomerType = ref<CustomerType>(CustomerType.B2C);
watch(customerTypeByFormData, (type) => {
    selectedCustomerType.value = type;
}, { immediate: true });
watch(selectedCustomerType, (type) => {
    if (type !== CustomerType.B2B) {
        setCompanyName('');
        setVatNumber('');
        selectedCustomerType.value = CustomerType.B2C;
    };
});

const { errors: emailErrors } = useField<string>('email');
const { errors: confirmEmailErrors } = useField<string>('confirmEmail');
const { value: alternativePhone } = useField<string>('alternativePhoneNumber');
const altPhoneIsToggledByData = computed<boolean>(() => alternativePhone.value?.length > 0 ?? false);
const altPhoneIsToggled = ref<boolean>(altPhoneIsToggledByData.value);
watch(altPhoneIsToggledByData, (toggled) => {
    altPhoneIsToggled.value = toggled;
}, { immediate: true });

const toggleAltPhone = () => {
    altPhoneIsToggled.value = true;
    emit('input');
};


return (_ctx: any,_cache: any) => {
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!
  const _component_InputPhone = _resolveComponent("InputPhone")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(InputText, {
        name: "email",
        label: _unref(labels).baseAddressEmail,
        "show-errors": false
      }, null, 8, ["label"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          mode: "out-in",
          name: "o-anim-fade-300"
        }, {
          default: _withCtx(() => [
            (_unref(emailErrors).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_InputErrorMessage, { name: "email" })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(labels).baseAddressEmailHelp), 1))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(InputText, {
        name: "confirmEmail",
        label: _unref(labels).baseAddressConfirmEmail,
        "show-errors": false
      }, null, 8, ["label"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_Transition, {
          mode: "out-in",
          name: "o-anim-fade-300"
        }, {
          default: _withCtx(() => [
            (_unref(confirmEmailErrors).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_InputErrorMessage, { name: "confirmEmail" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_InputPhone, {
      name: "phoneNumber",
      label: _unref(labels).baseAddressPhone
    }, null, 8, ["label"]),
    _createVNode(_Transition, {
      mode: "out-in",
      name: "o-anim-fade-300"
    }, {
      default: _withCtx(() => [
        (altPhoneIsToggled.value)
          ? (_openBlock(), _createBlock(_component_InputPhone, {
              key: 0,
              name: "alternativePhoneNumber",
              label: _unref(labels).baseAddressAltPhone
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (!altPhoneIsToggled.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "c-magic-line c-magic-line--underline text-dusty-grey mb-x6 block -mt-20",
          onClick: _withModifiers(toggleAltPhone, ["prevent"])
        }, _toDisplayString(_unref(labels).baseAddressAltPhoneButton), 9, _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}
}

})